import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative w-full bg-[#fafaf9] pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-68">
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-69">
        <div className="max-w-4xl mx-auto text-center" data-id="element-70">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-71">
            <span className="inline-block py-2 px-5 rounded-full bg-[#10b981]/10 text-[#10b981] text-base md:text-lg font-semibold mb-6" data-id="element-72">
              Plantilla de Finanzas Personales
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-stone-900 tracking-tight mb-6 leading-tight" data-id="element-73">
              ¿Sentís que tu dinero no te alcanza y no sabés por qué?
            </h1>
            <p className="text-lg md:text-xl text-stone-600 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-74">
              No sos el único. La mayoría no tiene un sistema claro para
              organizar sus finanzas. Esta plantilla en Google Sheets te ayuda a
              ordenar ingresos, gastos, ahorros y deudas de forma simple y sin
              complicaciones.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="flex flex-wrap justify-center gap-4 md:gap-8 mb-10 text-stone-700" data-id="element-75">
            {['Entendé en qué se va tu dinero', 'Organizá tus deudas sin estrés', 'Empezá a ahorrar con claridad', 'Todo en un solo lugar'].map((item, index) => <div key={index} className="flex items-center gap-2" data-id="element-76">
                <CheckCircle2 className="w-5 h-5 text-[#10b981]" data-id="element-77" />
                <span className="font-medium" data-id="element-78">{item}</span>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-79">
            <Button href="#precio" className="group" data-id="element-80">
              Empezar a ordenar mis finanzas
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-81" />
            </Button>
            <p className="mt-4 text-sm text-stone-500" data-id="element-82">
              Acceso inmediato • Pago único
            </p>
          </motion.div>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-83">
        <div className="absolute top-[-10%] left-[-5%] w-[30%] h-[30%] rounded-full bg-[#10b981]/5 blur-3xl" data-id="element-84" />
        <div className="absolute bottom-[-10%] right-[-5%] w-[30%] h-[30%] rounded-full bg-[#10b981]/5 blur-3xl" data-id="element-85" />
      </div>
    </section>;
}